/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedLayout_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedTrackingContainer_user">;
    readonly " $refType": "PdpSharedLayout_user";
};
export type PdpSharedLayout_user$data = PdpSharedLayout_user;
export type PdpSharedLayout_user$key = {
    readonly " $data"?: PdpSharedLayout_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedLayout_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedLayout_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '4d055eca3cf7a8b680bf82157ea283dc';
export default node;
